// extracted by mini-css-extract-plugin
export default {"loadingColor":"#44cc94","loading":"loading__1F1vn","loadingIcon":"loadingIcon__2z0Yz","spin":"spin__1x1yJ","loadingText":"loadingText__izlAv"};
    if(module.hot) {
      // 1764953338894
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  